import getFilePickerViewTypeValue from '../../../utils/getFilePickerViewTypeValue';
import { FilePickerViewType } from 'owa-filepicker';
import { updateUserConfigurationAndService } from 'owa-session-store';
import { logUsage } from 'owa-analytics';

export default function setUserPreferredViewType(viewType: FilePickerViewType) {
    const value = getFilePickerViewTypeValue(viewType);
    logUsage('AFPChangePreferredViewType', []);
    updateUserConfigurationAndService(
        configuration => {
            configuration.ViewStateConfiguration.AttachmentsFilePickerViewTypeForMouse = value;
        },
        [
            {
                key: 'AttachmentsFilePickerViewTypeForMouse',
                valuetype: 'Integer32',
                value: [`${value}`],
            },
        ],
        'OWA.ViewStateConfiguration'
    );
}
